import { Injectable } from '@angular/core';
import { AuthorizationBusinessService } from 'src/app/business/security/authorization-business.service';
import { User } from 'src/app/model/user';
import { StaticReportBusinessService } from 'src/app/business/reports/static-report-business.service';
import { ReportDefinition } from 'src/app/model/reports/report-definition';

export interface NavigationItem {
  id: string;
  title: string;
  type: 'item' | 'collapse' | 'group';
  translate?: string;
  icon?: string;
  hidden?: boolean;
  url?: string;
  classes?: string;
  exactMatch?: boolean;
  external?: boolean;
  target?: boolean;
  breadcrumbs?: boolean;
  function?: any;
  badge?: {
    title?: string;
    type?: string;
  };
  children?: Navigation[];
  permission: string;
}

export interface Navigation extends NavigationItem {
  children?: NavigationItem[];
}

const NavigationItems = [
  {
    id: 'home',
    title: 'Inicio',
    type: 'group',
    icon: 'feather icon-help-circle',
    children: [

      {
        id: 'analytics',
        title: 'Indicadores',
        icon: 'feather icon-home',
        type: 'item',
        url: '/dashboard/home',
        classes: 'nav-item',
        breadcrumbs: false,
        permission: "home_chart"
      },

    ]
  },
  {
    id: 'company',
    title: 'Configuración Empresa',
    type: 'group',
    icon: 'feather icon-monitor',
    children: [
      {
        id: 'organizationChart',
        title: 'Organigrama',
        icon: 'feather icon-globe',
        type: 'item',
        url: '/administration/organizationChart',
        classes: 'nav-item',
        breadcrumbs: false,
        permission: "admin_orgChart"
      },
      {
        id: 'licenseSetting',
        title: 'Licencia',
        icon: 'feather icon-unlock',
        type: 'item',
        url: '/company/licenseSetting',
        classes: 'nav-item',
        breadcrumbs: false,
        permission: "view_license"
      },
      {
        id: 'smtpSetting',
        title: 'Servicio SMTP',
        icon: 'feather icon-mail',
        type: 'item',
        url: '/company/smtpSetting',
        classes: 'nav-item',
        breadcrumbs: false,
        permission: "admin_SMTP"
      },
      {
        id: 'loginSetting',
        title: 'Autenticación BDM',
        icon: 'feather icon-cloud',
        type: 'item',
        url: '/company/loginSetting',
        classes: 'nav-item',
        breadcrumbs: false,
        permission: "admin_login"
      },
      {
        id: 'notifications',
        title: 'Notificaciones',
        icon: 'feather icon-bell',
        type: 'item',
        url: '/administration/notifications',
        classes: 'nav-item',
        breadcrumbs: false,
        permission: "adminNotify"
      },
      {
        id: 'calendar',
        title: 'Administración de calendario',
        icon: 'feather icon-calendar',
        type: 'item',
        url: '/company/calendar',
        classes: 'nav-item',
        breadcrumbs: false,
        permission: "admin_calendar"
      },
    ]
  },
  {
    id: 'admin',
    title: 'Administración General',
    type: 'group',
    icon: 'feather icon-monitor',
    children: [
      {
        id: 'application',
        title: 'Aplicaciones',
        icon: 'feather icon-layout',
        type: 'item',
        url: '/administration/application',
        classes: 'nav-item',
        breadcrumbs: false,
        permission: "admin_App"
      },
      {
        id: 'users',
        title: 'Usuarios',
        icon: 'feather icon-users',
        type: 'item',
        url: '/administration/users',
        classes: 'nav-item',
        breadcrumbs: false,
        permission: "admin_user"
      },
      {
        id: 'schemas',
        title: 'Esquemas',
        icon: 'feather icon-box',
        type: 'item',
        url: '/administration/schemas',
        classes: 'nav-item',
        breadcrumbs: false,
        permission: "admin_schema"
      },
      {
        id: 'attributes',
        title: 'Atributos',
        icon: 'feather icon-list',
        type: 'item',
        url: '/administration/attributes',
        classes: 'nav-item',
        breadcrumbs: false,
        permission: "admin_Attribute"
      },
      {
        id: 'rules',
        title: 'Reglas de Negocio',
        icon: 'feather icon-check-square',
        type: 'item',
        url: '/administration/rules',
        classes: 'nav-item',
        breadcrumbs: false,
        permission: "admin_workflow"
      },
      {
        id: 'workflow',
        title: 'Flujos de Aprobación',
        icon: 'feather icon-share-2',
        type: 'item',
        url: '/administration/workflow',
        classes: 'nav-item',
        breadcrumbs: false,
        permission: "admin_workflow"
      },
      {
        id: 'bpmnFlows',
        title: 'Diseñador de Flujos', 
        icon: 'feather icon-layers', 
        type: 'item',
        url: '/administration/bpmn-flows/process-list', 
        classes: 'nav-item',
        breadcrumbs: false,
        permission: "bpmn_workflows"
      },
      {
        id: 'report-designer',
        title: 'Diseñador Reportes',
        icon: 'fa fa-object-group',
        type: 'item',
        url: '/administration/report-designer',
        classes: 'nav-item',
        breadcrumbs: false,
        permission: "design_reports"
      },
    ]
  },
  {
    id: 'oper',
    title: 'Operación BRM',
    type: 'group',
    icon: 'feather icon-monitor',
    children: [

      {
        id: 'request',
        title: 'Solicitudes de Aprovisionamiento',
        icon: 'feather icon-inbox',
        type: 'item',
        url: '/requests/requestList',
        classes: 'nav-item',
        breadcrumbs: false,
        permission: "req_crea_supply"
      },
      {
        id: 'pamRequest',
        title: 'Solicitudes PAM',
        icon: 'feather icon-codepen',
        type: 'item',
        url: '/requests/pamRequest',
        classes: 'nav-item',
        breadcrumbs: false,
        permission: "pamRequest"
      },
      {
        id: 'pamDashboard',
        title: 'Cuentas PAM',
        icon: 'feather icon-sliders',
        type: 'item',
        url: '/dashboard/pamDashboard',
        classes: 'nav-item',
        breadcrumbs: false,
        permission: "pamDashboard"
      },
      {
        id: 'riskDashboard',
        title: 'Control Riesgos',
        icon: 'feather icon-alert-triangle',
        type: 'item',
        url: '/dashboard/riskDashboard',
        classes: 'nav-item',
        breadcrumbs: false,
        permission: "riskDashboard"
      },
      {
        id: 'endUserRequest',
        title: 'Permisos Asignados',
        icon: 'feather icon-shield',
        type: 'item',
        url: '/requests/endUserRequest',
        classes: 'nav-item',
        breadcrumbs: false,
        permission: "endUserRequest"
      },
      {
        id: 'task',
        title: 'Tareas',
        icon: 'fa fa-tasks',
        type: 'item',
        url: '/requests/task',
        classes: 'nav-item',
        breadcrumbs: false,
        permission: "myTasks"
      },
    ]
  },
  {
    id: 'admin',
    title: 'Operación BIM',
    type: 'group',
    icon: 'feather icon-monitor',
    children: [
      {
        id: 'organizationDomain',
        title: 'Niveles Organizacionales',
        icon: 'feather icon-globe',
        type: 'item',
        url: '/bim-administration/organizationDomain',
        classes: 'nav-item',
        breadcrumbs: false,
        permission: "admin_orgLevel"
      },
      {
        id: 'groupRequest',
        title: 'Solicitud de Grupos Seguridad',
        icon: 'feather icon-box',
        type: 'item',
        url: '/requests/groupRequest',
        classes: 'nav-item',
        breadcrumbs: false,
        permission: "groupRequest"
      },
      {
        id: 'userAccountRequestList',
        title: 'Solicitud Cuentas Usuario',
        icon: 'feather icon-user',
        type: 'item',
        url: '/requests/userAccountRequestList',
        classes: 'nav-item',
        breadcrumbs: false,
        permission: "userRequest"
      },
    ]
  },
];

@Injectable()
export class NavigationItem {
  user: User;
  constructor(private authorization: AuthorizationBusinessService, public reportBusiness: StaticReportBusinessService) {

  }

  navItems: Navigation[];
  public get() {
    this.navItems = [];
    this.user = this.authorization.GetUser();
    //Revisa Permisos
    NavigationItems.forEach((item) => {
      var newGroup = JSON.parse(JSON.stringify(item));
      newGroup.children = this.getChilds(item.children as Navigation[]);
      if (newGroup.children && newGroup.children.length > 0)
        this.navItems.push(newGroup);
    });
    // this.reportBusiness.GetReportList().then((repList: ReportDefinition[]) => {
    //   if (repList.length > 0) {
    //     var groups = repList.reduce((r, a) => {
    //       r[a.Group] = repList.filter(x => { return x.Group == a.Group });
    //       return r;
    //     }, {});

    //     var menuGroup: any = {
    //       id: 'rep',
    //       title: 'Reportes',
    //       type: 'group',
    //       icon: 'feather icon-monitor',
    //       children: [],

    //     };

    //     for (const key in groups) {
    //       var newGroup = {
    //         id: 'dashboard',
    //         title: key,
    //         type: 'collapse',
    //         icon: 'fa fa-file-invoice',
    //         permission: "*",
    //         children: []
    //       }
    //       groups[key].forEach((rep: ReportDefinition) => {
    //         newGroup.children.push({
    //           id: rep.Id,
    //           title: rep.Title,
    //           type: 'item',
    //           url: '/reports/basicReport/' + rep.ReportId,
    //           breadcrumbs: false,
    //           permission: rep.PermissionId
    //         });
    //       });
    //       menuGroup.children.push(newGroup);
    //     }
    //     this.navItems.push(menuGroup);
    //   }
    // });

    return this.navItems;
  }

  getChilds(items: Navigation[]): Navigation[] {
    let user = this.authorization.ValidateSession();
    if (!items)
      return null;
    var result: Navigation[] = [];
    items.forEach((item: Navigation) => {
      if (item.permission == "*" || this.user.Profile.Permissions.find(x => x == item.permission)) {
        let newItemNav = item;
        newItemNav.children = this.getChilds(newItemNav.children);
        if (newItemNav.type == "group" && newItemNav.children.length > 0)
          result.push(newItemNav);
        else
          result.push(newItemNav);
      }
    });
    return result;
  }

}
